import { useEffect, useRef, useState } from 'react';
import { api, type PlaceHit } from '@/lib/api';

/**
 * Címkeresés gépelés közben — a tervező pontjai és a Grout-chat „Egyik sem”
 * keresője közösen használja (#79).
 *
 * Késleltetett: minden leütésre kérni fizetős lenne (a geocoding külön
 * számlázódik), és a találatlista is ugrálna. A lassan érkező, már elavult
 * válasz eldobódik.
 */
export function usePlaceSearch(query: string, near?: { lat: number; lng: number } | null) {
  const [hits, setHits] = useState<PlaceHit[]>([]);
  const [searching, setSearching] = useState(false);
  const token = useRef(0);

  useEffect(() => {
    if (query.trim().length < 3) {
      setHits([]);
      return;
    }
    const current = ++token.current;
    setSearching(true);
    const timer = window.setTimeout(() => {
      void api
        .routesGeocode(query, near ?? undefined)
        .then((result) => {
          if (current === token.current) setHits(result.results);
        })
        .catch(() => {
          if (current === token.current) setHits([]);
        })
        .finally(() => {
          if (current === token.current) setSearching(false);
        });
    }, 350);
    return () => window.clearTimeout(timer);
  }, [query, near]);

  return { hits, searching, clear: () => setHits([]) };
}
